module.exports = __webpack_public_path__ + "static/img/connectc.9130e45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connectc.jpg
// module id = SJcj
// module chunks = 1